export default __webpack_public_path__ + "static/zaklepschronisko-promo@1x-8b1db7e5528b3aed0d34c505e7a5ea52.webp";